import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import LatestMatchesPage from "../components/latest-matches";
import * as actions from "./../redux/actions/catalogActions";

const mapStateToProps = (state) => {
  return {
    catalog: state.catalogReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return { actions: bindActionCreators(actions, dispatch) };
};

export default connect(mapStateToProps, mapDispatchToProps)(LatestMatchesPage);
